module.exports = __webpack_public_path__ + "static/media/UNCC-Crown.cbd40ed9.png";